export default "__VITE_ASSET__DnWAoAEl__"